import { render, staticRenderFns } from "./FbWrapper.vue?vue&type=template&id=900da5f0&scoped=true"
import script from "./FbWrapper.vue?vue&type=script&lang=js"
export * from "./FbWrapper.vue?vue&type=script&lang=js"
import style0 from "./FbWrapper.vue?vue&type=style&index=0&id=900da5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900da5f0",
  null
  
)

export default component.exports